import { StickyNoteColors } from "../enums/StickyNoteColors";
const presetColors = [
    "red",
    "blue",
    "green",
    "orange",
    "purple",
    "aqua",
    "aquamarine",
    "blueviolet",
    "cadetblue",
    "coral",
    "cornflowerblue",
    "cyan",
    "crimson",
    "darkviolet",
    "deeppink",
    "maroon",
    "fuchsia",
    "lime",
    "yellow",
    "teal",
    "darkgreen",
    "darkmagenta",
    "lightgreen"
];
const getRandomColor = () => {
    const randomIndex = Math.floor(Math.random() * presetColors.length);
    return presetColors[randomIndex];
};
const getRandomStickyNoteColor = () => {
    const colors = Object.values(StickyNoteColors);
    const randomIndex = Math.floor(Math.random() * colors.length);
    return colors[randomIndex];
};
const hexToRgba = (hex, alpha = 1) => {
    // Remove the hash at the start if it's there
    hex = hex.replace(/^#/, "");
    // Handle 3-digit hex codes
    if (hex.length === 3) {
        hex = hex
            .split("")
            .map((char) => char + char)
            .join(""); // Convert to 6-digit hex
    }
    // Ensure hex is a valid 6-digit code
    if (hex.length !== 6) {
        throw new Error("Invalid hex color.");
    }
    // Use bit shifting to extract the red, green, and blue values
    const intValue = parseInt(hex, 16); // Convert the hex to a number
    const r = (intValue >> 16) & 255; // Extract red
    const g = (intValue >> 8) & 255; // Extract green
    const b = intValue & 255; // Extract blue
    // Return the RGBA string with the passed alpha value
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};
export { getRandomColor, getRandomStickyNoteColor, hexToRgba };
